import { COMPANY } from "@/data/site";

export default function WhatsAppFloat() {
  const waNumber = COMPANY.whatsapp.replace(/[^0-9]/g, "");
  const text = encodeURIComponent(
    `Hello GTECGLOBAL, I'd like to request a quotation.`
  );
  return (
    <a
      data-testid="whatsapp-float-btn"
      href={`https://wa.me/${waNumber}?text=${text}`}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      className="wa-pulse fixed bottom-6 right-6 z-50 inline-flex h-14 w-14 items-center justify-center rounded-full bg-green-500 text-white shadow-lg shadow-green-500/30 transition-transform hover:scale-105"
    >
      <svg
        viewBox="0 0 32 32"
        width="26"
        height="26"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M19.11 17.21c-.31-.16-1.84-.91-2.12-1.01-.28-.1-.49-.16-.69.16-.21.31-.79 1-.97 1.21-.18.21-.36.23-.67.08-.31-.16-1.31-.48-2.49-1.54-.92-.82-1.54-1.84-1.72-2.15-.18-.31-.02-.48.14-.63.14-.14.31-.36.46-.54.16-.18.21-.31.31-.51.1-.21.05-.39-.03-.54-.08-.16-.69-1.67-.95-2.29-.25-.6-.51-.52-.69-.53l-.59-.01c-.21 0-.54.08-.82.39-.28.31-1.08 1.05-1.08 2.56s1.1 2.97 1.25 3.18c.16.21 2.16 3.31 5.24 4.64.73.32 1.3.51 1.74.65.73.23 1.39.2 1.91.12.58-.09 1.84-.75 2.1-1.48.26-.73.26-1.36.18-1.48-.08-.13-.28-.21-.59-.36zM16.02 4C9.39 4 4 9.4 4 16.04c0 2.12.55 4.18 1.59 6L4 28l6.13-1.61a11.97 11.97 0 0 0 5.89 1.53h.01c6.63 0 12.02-5.39 12.02-12.03 0-3.22-1.25-6.24-3.52-8.52A12.05 12.05 0 0 0 16.02 4zm0 21.91h-.01a9.93 9.93 0 0 1-5.05-1.38l-.36-.21-3.64.95.97-3.55-.24-.37a9.94 9.94 0 0 1-1.52-5.31c0-5.49 4.47-9.95 9.96-9.95 2.66 0 5.16 1.04 7.04 2.92a9.9 9.9 0 0 1 2.92 7.04c0 5.49-4.46 9.95-9.95 9.95z" />
      </svg>
    </a>
  );
}
